import * as React from 'react';

import { Select } from 'antd';
import type { SelectProps } from 'antd';

import { TelegramUser } from '../../types';

interface RecipientsPickerProps {
  value: TelegramUser[];
  onChange: (users: TelegramUser[]) => void;
  status?: 'error' | 'warning' | undefined;
  options?: TelegramUser[];
}

export function RecipientsPicker({ value, onChange, status, options = [] }: RecipientsPickerProps) {
  const selOptions: SelectProps['options'] = options.map((user) => ({
    label: `${user.name}${user.username ? ` (@${user.username})` : ''}`,
    value: user.id,
    user: user,
  })) as any;

  const handleChange = (selectedIds: string[]) => {
    const selectedUsers = selectedIds.map(id =>
      options.find(user => user.id === id)!
    ).filter(Boolean);
    onChange(selectedUsers);
  };

  return (
    <Select
      mode="multiple"
      status={status}
      allowClear
      showSearch
      value={value.map(user => user.id)}
      onChange={handleChange}
      options={selOptions}
      placeholder='Выберите получателей'
      style={{ width: '100%', maxWidth: 520 }}
      dropdownStyle={{ background: '#fff' }}
      filterOption={(input, option) => {
        const label = option?.label as string;
        return label.toLowerCase().includes(input.toLowerCase());
      }}
      maxTagCount={10}
      maxTagTextLength={40}
    />
  );
}
